export function getGodotBaseUrl(stemboxBranch?: string): string {
  return import.meta.env.VITE_GODOT_DEV_URL
    ? import.meta.env.VITE_GODOT_DEV_URL
    : `${import.meta.env.VITE_GODOT_PROJECTS_URL}/${stemboxBranch}`;
}
